import type { Ref } from 'vue'
import { nextTick } from 'vue'

type ListRef = Ref<HTMLElement | { $el?: HTMLElement } | undefined>

function getScrollContainer(optionElement: HTMLElement) {
  const container = optionElement.closest<HTMLElement>('.dropdown__scroll, .content')

  if (!container || container.scrollHeight <= container.clientHeight) {
    return null
  }

  return container
}

function scrollOptionIntoView(optionElement: HTMLElement) {
  const container = getScrollContainer(optionElement)

  if (!container) {
    return
  }

  const containerRect = container.getBoundingClientRect()
  const optionRect = optionElement.getBoundingClientRect()

  if (optionRect.top < containerRect.top) {
    container.scrollTop +=
      optionRect.top - containerRect.top - (container.clientHeight - optionElement.offsetHeight) / 2
  } else if (optionRect.bottom > containerRect.bottom) {
    container.scrollTop +=
      optionRect.bottom - containerRect.bottom + (container.clientHeight - optionElement.offsetHeight) / 2
  }
}

export async function focusOpenOption(list: ListRef) {
  await nextTick()

  const focus = () => {
    const listElement = list.value instanceof HTMLElement ? list.value : list.value?.$el
    const optionElement = listElement?.querySelector<HTMLElement>('[data-select-focus-target="true"]')

    if (optionElement) {
      scrollOptionIntoView(optionElement)
    }
  }

  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(focus)
    return
  }

  focus()
}
